// Demo data for customer invoices and payments
import type { InvoiceUI, PaymentUI } from '@/types/ui/customer-detail';
import { daysAgo } from './relative-date';

// Mock Invoices by customer ID.
// Customer '1' (Acme) is the only demo account with transaction detail; its three
// outstanding invoices sum to its outstanding balance (76k + 68k + 70k = 214k) and
// their weighted-average age matches Acme's DSO:
//   SUM(amount x daysSinceInvoice) / SUM(amount)
//   = (76000*118 + 68000*95 + 70000*70) / 214000 ~= 95 days (== mockCustomers[id:1].dso)
export const mockInvoicesByCustomerId: Record<string, InvoiceUI[]> = {
  '1': [
    {
      id: 'INV-001',
      date: daysAgo(118),
      dueDate: daysAgo(88),
      amount: 76000,
      status: 'overdue',
    },
    {
      id: 'INV-002',
      date: daysAgo(95),
      dueDate: daysAgo(65),
      amount: 68000,
      status: 'overdue',
    },
    {
      id: 'INV-003',
      date: daysAgo(70),
      dueDate: daysAgo(40),
      amount: 70000,
      status: 'overdue',
    },
  ],
};

// Mock Payments by customer ID
export const mockPaymentsByCustomerId: Record<string, PaymentUI[]> = {
  '1': [
    {
      id: 'PAY-001',
      date: daysAgo(20),
      amount: 50000,
      method: 'Wire Transfer',
      reference: 'WT-2023-001',
      allocations: [
        { invoiceId: 'INV-004', invoiceDate: daysAgo(150), amount: 30000 },
        { invoiceId: 'INV-005', invoiceDate: daysAgo(140), amount: 20000 },
      ],
    },
    {
      id: 'PAY-002',
      date: daysAgo(35),
      amount: 35000,
      method: 'ACH',
      reference: 'ACH-2023-002',
      allocations: [{ invoiceId: 'INV-006', invoiceDate: daysAgo(160), amount: 35000 }],
    },
  ],
};
